import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./BarChart.css";
const BarChart2 = ({ categories = [], series = [] }) => {
  const options = {
    chart: {
      type: "column",
      // type: "columnrange",
    },
    rangeSelector: {
      selected: 2,
    },
    title: {
      text: "Number of Reservations Vs Reservation Source",
      align: "left",
    },
    xAxis: {
      categories,
      crosshair: true,
      accessibility: {
        description: "Reservation Source",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Reservations",
      },
    },
    // tooltip: {
    //   valueSuffix: " (1000 MT)",
    // },
    tooltip: {
      pointFormat:
      "OTA: <b>{point.category}</b><br>" +
        "Reservations: <b> {point.y}</b><br>",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        minPointLength: 3,
      },
    },
    series: [
      {
        name: "Reservation Source",
        data: series,
      },
    ],
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
export default BarChart2;